import styled from 'styled-components';

import Text from 'components/_core/Text';
import Form from 'components/Form';
import Row from 'components/Row';

export const ManageElement = {
  BusinessRoleDescription: styled(Text)`
    display: inline-block;
    margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
  `,
  BusinessRoleLabel: styled(Text).attrs({
    fontWeight: 'weight-500',
    variant: 'primary',
  })`
    display: inline-block;
    margin-bottom: ${({ theme }) => theme.spacings.abs4}px;
  `,
  CardHeader: styled(Row).attrs({
    alignItems: 'center',
    justifyContent: 'space-between',
  })`
    margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
  `,
  MissingInfoContainer: styled(Text).attrs({
    color: 'red.-2',
    size: 'sm',
  })`
    margin-top: ${({ theme }) => theme.spacings.abs4}px;
  `,
  RoleContainer: styled(Text).attrs<{ disabled: boolean }>(({ disabled }) => ({
    size: 'sm',
    variant: disabled ? 'disabled' : 'light',
  }))`
    margin-top: ${({ theme }) => theme.spacings.abs4}px;
  `,
  Wrapper: styled(Form)`
    width: 100%;
  `,
};
